const Contact = () => {
    return (<>
        <div className="row  box border">
            <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12">
                <h1>Contact Us</h1>
                <p>
                    Delfin always enjoys hearing from our customers, whether
                    they are returning or new and we look forward to earning your business and
                    trust.
                </p>

                <p>
                    <strong>Delfin Technologies, Inc.</strong><br />
                    Bonita Springs, Florida <br />
                    Phone: 612.749.5954<br />
                    Email: <a href="mailto:jeff@tortugadesign.com">jeff@tortugadesign.com</a>
                </p>

            </div>
        </div>
    </>)
}
export default Contact;